export enum RadioStatus {
  nochecked = 'nochecked',
  checked = 'checked',
  disabled = 'disabled',
}
